import React from 'react';

import { designTokens, Flex, Typography } from '@project44/manifest-ds';
import { useTranslation } from '@project44/translations-utils';

import mailIcon from '../../resources/Mail.svg';

const EmailSuccess = ({ username }: { username: string }): JSX.Element => {
  const { t, t__react } = useTranslation();

  return (
    <Flex
      css={{
        width: '100%',
        gap: designTokens.spaceSmall,
        padding: designTokens.spaceSmall,
        background: designTokens.colorBackgroundSecondary,
        alignItems: 'flex-start',
      }}
    >
      <img
        src={mailIcon}
        data-testid="email"
        alt={t('resetPasswordResponse.emailIcon')}
      />
      <Typography
        variant="subtext"
        css={{ position: 'relative', bottom: designTokens.spaceXSmall }}
      >
        {t__react('resetPasswordResponse.emailSuccess', {
          resetPasswordUsernameSuccessComponent: (
            <Typography variant="subtextBold">{username}</Typography>
          ),
        })}
      </Typography>
    </Flex>
  );
};

export default EmailSuccess;
